import { AggregatedReportWidget, REPORT_COMPANY_DETAILS } from '../../../../../../types';

export const isCompanyDetailsWidget = (widget: AggregatedReportWidget) => {
  return (
    widget?.widgetDataType === REPORT_COMPANY_DETAILS.ESG_OPPORTUNITIES ||
    widget?.widgetDataType === REPORT_COMPANY_DETAILS.ESG_RISK_LEVEL ||
    widget?.widgetDataType === REPORT_COMPANY_DETAILS.GOVERNANCE_SCORE
  );
};
